import TableHeader from './TableHeader/TableHeader'
import TableItem from './TableItem/TableItem'

import useStyles from './useStyles'

function ProductsTable ({ rows, setRows, suscriber, setLoading }) {
  const classes = useStyles()

  return (
    <>
      <div className={classes.root}>
        <div className={classes.tableWrap}>
          <table className={classes.table}>
            <TableHeader />

            <tbody className={classes.tableBody}>
              {rows.map((item, index) => (
                <TableItem
                  listIndex={index}
                  key={item.product_subscription_id}
                  item={item}
                  suscriber={suscriber}
                  setLoading={setLoading}
                />
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </>
  )
}
export default ProductsTable
